import { useTranslation } from "react-i18next";
import useEvent from "react-use-event-hook";
import { useRecoilValue } from "recoil";

import { errors, Log, SimpleResult } from "@ryde/shared";

import { landingRoutesApiConst } from "../constants";
import { ILandingProfileDto } from "../models";
import { landingCompanyIdSelector } from "../selectors";
import { useLandingApiMethods } from "./use-landing-api-methods";

export const useLandingApiProfile = () => {
  const companyId = useRecoilValue(landingCompanyIdSelector);
  const profileUrl = landingRoutesApiConst.profile(companyId as number);
  const { apiGet } = useLandingApiMethods();
  const { t } = useTranslation();

  const getLandingProfile = useEvent(
    async (): Promise<SimpleResult<ILandingProfileDto> | undefined> => {
      if (!Number(companyId)) {
        Log.warnAndToast(t(errors.common.invalidId));
        return undefined;
      }

      const response = await apiGet<SimpleResult<ILandingProfileDto>>(
        profileUrl.fetch,
      );

      return response?.data;
    },
  );

  return { getLandingProfile };
};
